import { Suspense } from 'react';
import { AppBar, Box, Container, Menu, Spinner, theme, VStack } from '@bpba/ui-components';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { MENU_LINKS } from '../constants';
import { InfoTurneroModal } from '../features/turnero/components/InfoTurneroModal';
import { useTurnero } from '../context/TurneroContext';
import { useState, useEffect } from 'react';

export const Layout = () => {
  const { pathname, state } = useLocation();
  const navigate = useNavigate();
  const { resetSesion } = useTurnero();
  const [infoSeen, setInfoSeen] = useState(() => sessionStorage.getItem('_bpba_e2e') === '1');

  const activeValue = pathname === '/' ? 'solicitar' : pathname.split('/')[1];

  useEffect(() => {
    if ((state as any)?.reopenDisuasion) {
      setInfoSeen(false);
      navigate(pathname, { replace: true, state: null });
    }
  }, [state, pathname, navigate]);

  // Cada vez que cambia la ruta (flow → flow) llevamos el viewport al top.
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);

  return (
    <Box
      flexDirection="column"
      alignItems="center"
      style={{ backgroundAttachment: 'fixed' }}
      minHeight={theme.header.withAppBar.dynamic.responsive.map((h) => `calc(100dvh - ${h})`)}
    >
      <AppBar title="Turnos Web" />
      <InfoTurneroModal show={!infoSeen} onContinue={() => setInfoSeen(true)} />
      <Container
        as="main"
        flex={1}
        mt={['12px', null, null, null, '24px']}
        mb={'48px'}
      >
        <VStack gap={['24px', null, null, null, '32px']} alignItems="stretch" flex={1}>
          <Menu
            items={MENU_LINKS}
            value={activeValue}
            mode="horizontal"
            onChange={(item) => {
              if (item.href !== pathname) resetSesion();
              navigate(item.href!);
            }}
          />
          <VStack flex={1}>
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </VStack>
        </VStack>
      </Container>
    </Box>
  );
};

const Loader = () => (
  <Box justifyContent="center" alignItems="center" minHeight="40vh">
    <Spinner size="40px" color={theme.colors.primary[0]} />
  </Box>
);
